module.exports = __webpack_public_path__ + "img/radiobutton_power_green.4cc45eef.svg";